export default function ImageViewer(props) {
    if (!props.image) {
        return <img alt='' {...props} src='/logo.svg' />
    }

    if (props.xs) {
        return <img alt='' {...props} src={`https://ik.imagekit.io/verticode/${props.image}?tr=w-100`} />
    }

    if (props.small) {
        return <img alt='' {...props} src={`https://ik.imagekit.io/verticode/${props.image}?tr=w-600`} />
    }

    return <img alt='' {...props} src={`https://ik.imagekit.io/verticode/${props.image}`} />
}
